import React, { useState } from "react";
import "./CouponList.css";

const CouponList = ({ coupons }) => {
  const [copiedCode, setCopiedCode] = useState(null);

  const copyToClipboard = (code) => {
    navigator.clipboard.writeText(code);

    setCopiedCode(code);

    setTimeout(() => {
      setCopiedCode(null);
    }, 2000);
  };

  if (!coupons || coupons.length === 0) {
    return null;
  }

  return (
    <div className="coupons-section">
      <div className="section-header">
        <div>
          <h3 className="section-title">🎁 Best Offers</h3>
          <p className="section-subtitle">Save more with exclusive deals</p>
        </div>
      </div>

      <div className="coupons-grid">
        {coupons.map((coupon) => (
          <div
            className={`coupon-card ${coupon.expired ? "expired-coupon" : ""}`}
            key={coupon.id}>
            <div className="coupon-left">
              <div className="coupon-icon">🎟️</div>

              <div>
                <h4 className="coupon-code">{coupon.code}</h4>

                <p className="coupon-desc">
                  {coupon.type === "percent"
                    ? `${coupon.value}% OFF`
                    : `₹${coupon.value} OFF`}

                  {coupon.min_amount
                    ? ` • Min order ₹${coupon.min_amount}`
                    : ""}
                </p>

                {coupon.expiry_date && (
                  <p className="coupon-expiry">
                    Expires {new Date(coupon.expiry_date).toLocaleDateString()}
                  </p>
                )}
              </div>
            </div>

            <button
              className="coupon-btn"
              onClick={() => copyToClipboard(coupon.code)}>
              {copiedCode === coupon.code ? "Copied" : "Copy"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CouponList;
